import React from 'react'
import { FilterableTableHeader, SortableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import LocationNameCell from '../tableCells/locationName/LocationNameCell'
import CityCountyPosterCell from '../tableCells/cityCounty/CityCountyPosterCell'
import TooltipComponent from '../../../../../app/components/headerTooltip'
import AddressCell from '../tableCells/AddressCell'
import UpdateServiceCell from '../tableCells/UpdateServiceCell'
import UpdateServiceTooltip from '../toolTips/UpdateServiceTooltip'
import CityCountyTooltip from '../toolTips/CityCountyTooltip'

const postingsLocationsTableColumns = ({ sortOptions, filterOptions, eventHandlers, refreshPostingsLocations }) => {
  const cityCountyFilterCheck = filterOptions.cityCountyPoster && filterOptions.cityCountyPoster.display

  return [
    {
      Header: () => (
        <SortableTableHeader
          field="displayName"
          text="Name"
          sortOptions={sortOptions}
          eventHandlers={eventHandlers}

        />
      ),
      width: 450,
      accessor: 'name',
      Cell: ({ cell }) => (
        <LocationNameCell
          location={cell.row.original}
          refreshPostingsLocations={refreshPostingsLocations}
        />
      )
    },
    {
      Header: () => (
        <SortableTableHeader
          field="address"
          text="Address"
          sortOptions={sortOptions}
          eventHandlers={eventHandlers}
        />
      ),
      accessor: 'addressObject',
      width: 450,
      Cell: ({ cell }) => (
        <AddressCell
          locationAddress={cell.row.original.addresses[0]}
        />
      )
    },
    {
      Header: 'Update Service',
      accessor: 'updateService',
      width: 900,
      Cell: ({ cell }) => (
        <UpdateServiceCell
          location={cell.row.original}
        />
      ),
      toolTip: <TooltipComponent toolTip={<UpdateServiceTooltip />} />,
      canSort: false
    },
    {
      Header: () => (
        <FilterableTableHeader
          field="cityCountyPoster"
          text={cityCountyFilterCheck ? filterOptions.cityCountyPoster.display : 'City/County'}
          selection={[
            ['Clear Filter', ''],
            ['City', 'city'],
            ['County', 'county'],
            ['City/County', 'city,county']
          ]}
          filterOptions={filterOptions}
          eventHandlers={eventHandlers}
        />
      ),
      accessor: 'cityCountyPoster',
      width: 325,
      canSort: false,
      Cell: ({ cell }) => (
        <CityCountyPosterCell
          posters={cell.row.original.posters}
        />
      ),
      toolTip: <TooltipComponent toolTip={<CityCountyTooltip />} />
    }
  ]
}

export default postingsLocationsTableColumns
